import React, { Component } from 'react';
import './item.css';
import './item-stats.css';
import './item-stats-front.css';
import './item-stats-back.css';
import './item-stats-tabs.css';
import './item-milestone.css';
import * as d3 from 'd3';

class Item extends Component {
	constructor(props) {
		super(props);		
		
		this.abstract = this.abstract.bind(this);
		
		this.state = { "abstractLength": 150 };
	}
	
	abstract( text, length ) {
		var trimmedString;
		if ( text.length >= length ) {
			trimmedString = text.substr(0, length);
			trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))  + "…";
		} else {
			trimmedString = text;
		}
		return trimmedString.trim();
  	}
  
  	render() {
	  	let popular = ( parseInt(this.props.Article.popularity, 10) >= 1000000 ) ? true : false; 
	    if (this.props.Article.type === 'milestone') {
		    return <Milestone Article={this.props.Article} />
		} else {   
		    return (
				<li className={"item article " + ( popular ? 'popular ' : '' ) }>
					<article>
						<header>
							<h2>{this.props.Article.source} / <time dateTime={this.props.Article.date_published}>{this.props.Article.short_published}</time></h2>
							<h1><a href={this.props.Article.url} target="_read" rel="noopener"><span>{this.props.Article.title}</span></a></h1>
						</header>
							<Collections Items={this.props.Article.collections} Filtered={this.props.Filtered} />						
							<p><a href={this.props.Article.url} target="_read" rel="noopener">{this.abstract( this.props.Article.description, this.state.abstractLength )}</a></p>
						<footer>
							<Tags Items={this.props.Article.tags} />
							<Stats Slug={this.props.Slug} Name={this.props.Name} ShortName={this.props.ShortName} Stats={this.props.Stats} Article={this.props.Article} FetchContent={this.props.FetchContent} PopularityUrl={this.props.PopularityUrl} BaseUrl={this.props.BaseUrl} />
						</footer>
					</article>
				</li>
		    );
		}
	}
}

export default Item;

class Tags extends Component {
	render() {
	    if ( this.props.Items && this.props.Items.length > 0) {
	    	return (
				<div className="tags-wrapper">
					<ul className="tags">
						<li className="intro">Tags:</li>
						{
							this.props.Items.map(
								function(tag, index) {
									return <Tag key={tag + '-' + index} Tag={tag} />
								}
							)
						}
					</ul>
				</div>
			);
		} else {
			return null;
	  	}
	}
}
class Tag extends Component {
	render() {
		return (
			<li className="tag"><a href={"#/filtra/" + escape(this.props.Tag.trim())}><span>{this.props.Tag.trim()}</span></a></li>
		)
	}
}

class Collections extends Component {
	render() {
	    if ( this.props.Items && this.props.Items.length > 0) {
	    	return (
				<div className="collections-wrapper">
					<ul className="collections">
						{
						this.props.Items.map(
							(collection) => {
								return <li className={"collection " + collection.slug} key={collection.id}><a href={"#/categoria/" + collection.slug}><span>{collection.name}</span></a></li>
								}
							)
						}
					</ul>
				</div>
			);
		} else {
			return null;
	  	}
	}
}

class Stats extends Component {
	constructor(props) {
		super(props);	
		
		this.getLn = this.getLn.bind(this);	
		this.switchView = this.switchView.bind(this);	
		
		this.state = {
			"itemProps": {},
			"avgProps": {},
			"avgCollectionProps": {},
			"showBack": false
		};
	}
	
	componentDidUpdate( prevProps, prevState ) {
		var itemProps = {},
			avgProps = {},
			avgCollectionProps = {},
			percent,
			lnBase = 2;
		if ( this.props.Stats && prevProps.Stats !== this.props.Stats ) {
			percent = ( 100 * this.getLn(parseInt(this.props.Article.popularity, 10) , lnBase ) / this.getLn(parseInt(this.props.Stats.global.popularity.max, 10) , lnBase ) );
			itemProps = {
			    "left": (percent < 50) ? Math.round( percent ) + '%' : 'auto',
			    "right": (percent < 50) ? 'auto' : (100 - percent) + '%'
		    };
		    percent = ( 100 * this.getLn(parseInt(this.props.Stats.global.popularity.avg, 10) , lnBase ) / this.getLn(parseInt(this.props.Stats.global.popularity.max, 10) , lnBase ) );
		    avgProps = {
			    "left": (percent < 50) ? Math.round( percent ) + '%' : 'auto',
			    "right": (percent < 50) ? 'auto' : (100 - percent) + '%'
		    };
			if ( this.props.Stats.collection ) {
			    percent = ( 100 * this.getLn( ( parseInt(this.props.Stats.collection.popularity, 10) ), lnBase ) / this.getLn( parseInt(this.props.Stats.global.popularity.max, 10), lnBase ) );
			    avgCollectionProps = {
				    "left": (percent < 50) ? Math.round( percent ) + '%' : 'auto',
				    "right": (percent < 50) ? 'auto' : (100 - percent) + '%'
			    };
		    } else {
			    avgCollectionProps = {
				    "display": "none",
				    "right": null,
				    "left": null
				};
		    }
			this.setState({ "itemProps": itemProps, "avgProps": avgProps, "avgCollectionProps": avgCollectionProps });
		}
	}
	
	switchView( side ) {
		this.setState( { "showBack": side } );
	}
	
	getLn( val, base ) {
		if ( base > 0 ) {
			return Math.log( val ) / Math.log( base );
		} else {
			return Math.log( val )
		}
	}
	
	render() {
		var popularity = ( this.props.Article.popularity !== undefined ) ? parseInt( this.props.Article.popularity, 10 ) : 0;
	    if ( this.props.Stats && popularity >= 10 ) {
		    var classes = (( this.props.Stats.collection ) ? this.props.Slug : ''); 
		    return (
				<div className={"stats-wrapper " + (( this.state.showBack ) ? 'show-back' : 'show-front' )}>
					<div className="in">
						<StatsTabs ShowBack={this.state.showBack} switchView={this.switchView} Logs={this.props.Article.popularity_logs} />
						<div className="stats-tabs-content">
							<div className="in">
								<StatsFront Id={this.props.Article.id} AvgProps={this.state.avgProps} AvgCollectionProps={this.state.avgCollectionProps} ShortName={this.props.ShortName} ItemProps={this.state.itemProps} Classes={classes} />
								<StatsBack Id={this.props.Article.id} Logs={this.props.Article.popularity_logs} FetchContent={this.props.FetchContent} Active={( this.state.showBack ? true : false )} PopularityUrl={this.props.PopularityUrl} BaseUrl={this.props.BaseUrl} Classes={classes} />
							</div>
						</div>
					</div>
				</div>
			);
		} else {
			return null;
	  	}
	}
}

class StatsFront extends Component {
	render() {
		return <div className="stats-front">
			<div className="in">		
				<div className={"item-stats item-stats-" + this.props.Classes} id={"item-stats-" + this.props.Id }>
					<div className="item-stats-group in" id={"item-stats-group-" + this.props.Id }>
						<div className="item-stats-line" id={"item-stats-line-" + this.props.Id} />
						<div className={"item-stats-rect-avg " + ((this.props.AvgProps.right !== 'auto') ? 'invert' : '')} id={"item-stats-rect-avg-" + this.props.Id} style={this.props.AvgProps}><div className="in">Popolarità media</div></div>
						<div className={"item-stats-rect-collection-avg " + ((this.props.AvgCollectionProps.right !== 'auto') ? 'invert' : '')} id={"item-stats-rect-collection-avg-" + this.props.Id} style={this.props.AvgCollectionProps}><div className="in">Popolarità media {this.props.ShortName}</div></div>
						<div className={"item-stats-rect-item " + ((this.props.ItemProps.right !== 'auto') ? 'invert' : '')} id={"item-stats-rect-item-" + this.props.Id} style={this.props.ItemProps}><div className="in">Popolarità</div></div>
						
					</div>
				</div>
			</div>
		</div>
	}
}

class StatsBack extends Component {
	constructor(props) {
		super(props);	
		
		this.draw = this.draw.bind(this);
		this.load = this.load.bind(this);
		this.viewbox = this.viewbox.bind(this);
		this.dateFormat = this.dateFormat.bind(this);
		
		this.state = {
			"lines": [],
			"log": [],
			"loading": true,
			"path": null,
			"size": {
				"w":300,
				"h":90
			}
		};
	}
	
	componentDidMount() {
		window.addEventListener( 'resize', this.viewbox, false );
	}
	
	componentWillUnmount() {
		window.removeEventListener( 'resize', this.viewbox, false );
	}
	
	componentDidUpdate( prevProps, prevState ) {
		if ( prevProps.Active !== this.props.Active && this.props.Active === true && this.state.log.length === 0 ) {
			this.load();
		}
	}
	
	viewbox() {
		if ( document.querySelector('#chart-pop-' + this.props.Id) !== null ) {
			var size = {
				"w": document.querySelector('#chart-pop-' + this.props.Id + " .stats-detail-chart-wrapper").offsetWidth,
				"h": document.querySelector('#chart-pop-' + this.props.Id + " .stats-detail-chart-wrapper").offsetHeight
			}
			this.setState( { 'size': size }, () => { if ( this.state.log.length > 0 ) { this.draw(); } });
		}
	}
	
	dateFormat(timestamp) {
		const d = new Date( timestamp * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		const hh = "00" + d.getHours();
		const nn = "00" + d.getMinutes();
		return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2) + ' ' + hh.substr(hh.length - 2) + ':' + nn.substr(nn.length - 2) ;
	}
	
	draw() {
		var scaleX = d3.scaleLinear()
            .domain([this.state.log[0].timestamp_added,this.state.log[(this.state.log.length-1)].timestamp_added])
            .range([0,this.state.size.w]);
		
		var scaleY = d3.scaleLinear()
            .domain([(this.state.log[0].popularity * .85), this.state.log[(this.state.log.length-1)].popularity])
            .range([this.state.size.h,0]);
            
        var points = [ { "x": 0, "y": this.state.size.h } ];
        for ( var i=0, l=this.state.log.length; i<(l); i++ ) {
	        points.push( { "x": scaleX(this.state.log[i].timestamp_added), "y": scaleY(this.state.log[i].popularity) } );
	    }
	    
	    const area = d3.area()
			.x( points => points.x )
			.y1( points => points.y )
			.y0( points => this.state.size.h )
			.curve( d3.curveBasis );
		
		var lines = [];
		for ( var j=1, m=this.state.log.length; j<(m-1); j++ ) {
	        lines.push( { "x": scaleX(this.state.log[j].timestamp_added) } );
	    }
		
				
		this.setState( { "lines": lines, "loading": false, "path": area( points ) } );
	}
	
	load() {
		var location = this.props.BaseUrl + this.props.PopularityUrl + '/' + this.props.Id;
		
		this.props.FetchContent(
			location,
			{},
			(data) => {
				if ( data.error ) {
					console.log( data.errormessage );
				} else {
					this.setState( { "log": data.log.reverse() }, () => { this.viewbox(); } );
				}
			},
			(error) => {
				console.log( error );
			}
		);
	}
	
	render() {
		if ( parseInt(this.props.Logs, 10) > 1 && this.state.log.length > 1 ) {
			let h = this.state.size.h;
			return <div className={"stats-back " + (this.state.loading ? 'loading' : '')}>
				<div className="in">
					<div className="loading">
						<div className="in">
							<svg className="stats-logo-small" preserveAspectRatio="xMidYMid meet" width="426px" height="426px" viewBox="0 0 426 426">
								<g className="stats-logo-small-group" transform="translate(0.000000, 84.000000)">
									<rect className="stats-logo-small-red" transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) " x="205.693434" y="37.6934342" width="182" height="182"></rect>
									<rect className="stats-logo-small-green" transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) " x="38" y="38" width="182" height="182"></rect>
								</g>
							</svg>
						</div>
					</div>
					<div className={"chart chart-" + this.props.Classes} id={'chart-pop-' + this.props.Id}>
						<div className="in">
							<div className="stats-detail-chart-wrapper">
								<div className="in">
									<svg className="stats-detail-chart" preserveAspectRatio="xMidYMid meet" viewBox={"0 0 " + this.state.size.w + " " + this.state.size.h}>
										<g className="stats-detail-chart-path">
											<path d={this.state.path} />
										</g>
										<g className="stats-detail-chart-lines">
											{
												this.state.lines.map(
													function(line) {
														return <line key={line.x} x1={line.x} y1={0} x2={line.x} y2={h} />
													}
												)
											}
										</g>
									</svg>
								</div>
							</div>
							<div className="y-axis">+<br />⇡<br />Pop<br />⇣<br />-</div>
							<div className="x-axis-start">{this.dateFormat( this.state.log[0].timestamp_added )}</div>
							<div className="x-axis-legend">⇢ Tempo ⇢</div>
							<div className="x-axis-end">{this.dateFormat( this.state.log[(this.state.log.length-1)].timestamp_added )}</div>
						</div>
					</div>
				</div>
			</div>
		} else {
			return null;
		}
	}
}

class StatsTabs extends Component {
	constructor(props) {
		super(props);
		
		this.switchView = this.switchView.bind(this);
		
		this.state = {
			"labels": [],
			"log": [],
			"loading": true,
			"path": null,
			"size": {
				"w":300,
				"h":90
			}
		};
	}
	
	switchView( e, side ) {
		e.preventDefault();
		if ( side === 'back' ) {
			side = true;
		} else {
			side = false;
		}
		this.props.switchView( side );
	}
	
	render() {
		if ( parseInt(this.props.Logs, 10) > 1) {
			return <div className="stats-tabs">
				<ul>
					<li className={"stats-tab " + ( this.props.ShowBack ? '' : 'active' )  }><a href="#/stats/front" onClick={ (e) => { this.switchView( e, 'front' ); }}>Popolarità articolo {this.props.showBack}</a></li>
					<li className={"stats-tab " + ( this.props.ShowBack ? 'active' : '' )  }><a href="#/stats/front" onClick={ (e) => { this.switchView( e, 'back' ); }}>Evoluzione popolarità</a></li>
				</ul>
			</div>
		} else {
			return <div className="stats-tabs">
				<ul>
					<li className="stats-tab active"><a>Popolarità articolo</a></li>
				</ul>
			</div>
		}
	}
}

class Milestone extends Component {
	
	dateFormat(timestamp) {
		const d = new Date( timestamp * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		const yy = d.getFullYear();
		return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2) + '/' + yy;
	}
	
	render() {
		return ( 
			<li className="item article milestone">
				<article>
					<header>
						<h2>Temi - <time dateTime={this.props.Article.date_published}>{ this.dateFormat( this.props.Article.timestamp_published )}</time></h2>
						<h1><span>{this.props.Article.title}</span></h1>
					</header>
					<div className="milestone-body">
						<div className="milestone-text">
							<p>{this.props.Article.description} — <a href={this.props.Article.url} target="_read" rel="noopener">Leggi l'articolo su {this.props.Article.source}</a></p>
						</div>
						<footer>
							<h4>Ricerche correlate:</h4>
							<ul>
								{this.props.Article.tags.map(
									function(tag) {
										return <Tag key={tag} Tag={tag} />
										}
								)} 
							</ul>
						</footer>
					</div>
				</article>
			</li>
		)
	}
}




// WEBPACK FOOTER //
// ./src/Elezioni/item.js